import type { Event } from '@sentry/react';

export const SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  // Zalo アプリの内部ブラウザが注入するスクリプト由来のエラー
  // Safari: "Can't find variable: zaloJSV2"
  // Chrome: "zaloJSV2 is not defined"
  /zaloJSV2/,
  // ブラウザ拡張機能が閉じられたタブへ sendMessage を試みた際のエラー
  // "Invalid call to runtime.sendMessage(). Tab not found."
  /Invalid call to runtime\.sendMessage\(\)/,
];

export const isIgnoredSentryError = (message: string): boolean =>
  SENTRY_IGNORE_ERRORS.some((pattern) =>
    typeof pattern === 'string'
      ? message.includes(pattern)
      : pattern.test(message)
  );

// Safari の DOM 実装と React の reconciliation の競合で、react-dom の
// commitDeletionEffectsOnFiber が native removeChild を呼んだ際に発生する DOMException (code=8)
// "NotFoundError: The object can not be found here."
// メッセージだけでは他の DOM エラーと区別できないため、最内フレームが native (`[native code]`) の removeChild であることも要求する
const SAFARI_NOT_FOUND_MESSAGE = /^The object can not be found here\.?$/;

export const isSafariReactRemoveChildError = (event: Event): boolean => {
  const values = event.exception?.values ?? [];
  return values.some((exception) => {
    if (exception.type !== 'NotFoundError') return false;
    if (!SAFARI_NOT_FOUND_MESSAGE.test(exception.value ?? '')) return false;
    const frames = exception.stacktrace?.frames ?? [];
    const innermost = frames[frames.length - 1]; // Sentry の frames は最内が末尾
    return (
      innermost?.function === 'removeChild' &&
      innermost.filename === '[native code]'
    );
  });
};

export const filterSentryEvent = (event: Event): Event | null =>
  isSafariReactRemoveChildError(event) ? null : event;
